import { createSlice } from '@reduxjs/toolkit';

// Initial state
const initialState = {
  // Authentication
  token: null,
  currentUser: null,

  // Current context
  currentAssessmentUuid: null,
  currentModelId: null,

  // App state
  isInitialized: false,
  isInitializing: false,
  initError: null,

  // UI state
  sidebarOpen: true,
  theme: 'light',
};

// Slice
const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    // Authentication
    setToken: (state, action) => {
      state.token = action.payload;
    },

    setCurrentUser: (state, action) => {
      state.currentUser = action.payload;
    },

    clearAuth: (state) => {
      state.token = null;
      state.currentUser = null;
    },

    // Current context
    setCurrentAssessment: (state, action) => {
      state.currentAssessmentUuid = action.payload;
    },

    setCurrentModel: (state, action) => {
      state.currentModelId = action.payload;
    },

    clearCurrentContext: (state) => {
      state.currentAssessmentUuid = null;
      state.currentModelId = null;
    },

    // App initialization state
    resetInitialization: (state) => {
      state.isInitialized = false;
      state.isInitializing = false;
      state.initError = null;
    },

    setInitializing: (state, action) => {
      state.isInitializing = action.payload;
      if (action.payload) {
        state.initError = null;
      }
    },

    setInitialized: (state, action) => {
      state.isInitialized = action.payload;
      state.isInitializing = false;
    },

    setInitError: (state, action) => {
      state.initError = action.payload;
      state.isInitializing = false;
    },

    // UI state
    toggleSidebar: (state) => {
      state.sidebarOpen = !state.sidebarOpen;
    },

    setSidebarOpen: (state, action) => {
      state.sidebarOpen = action.payload;
    },

    setTheme: (state, action) => {
      state.theme = action.payload;
    },
  },
});

export const {
  // Authentication
  setToken,
  setCurrentUser,
  clearAuth,
  // Current context
  setCurrentAssessment,
  setCurrentModel,
  clearCurrentContext,
  // Initialization
  resetInitialization,
  setInitializing,
  setInitialized,
  setInitError,
  // UI
  toggleSidebar,
  setSidebarOpen,
  setTheme,
} = appSlice.actions;

// Selectors
export const selectToken = (state) => state.app.token;
export const selectCurrentUser = (state) => state.app.currentUser;
export const selectIsInitialized = (state) => state.app.isInitialized;
export const selectIsInitializing = (state) => state.app.isInitializing;
export const selectInitError = (state) => state.app.initError;
export const selectCurrentAssessmentUuid = (state) => state.app.currentAssessmentUuid;
export const selectCurrentModelId = (state) => state.app.currentModelId;

export default appSlice.reducer;
